// Auto-refactored from translations.js on 2026-08-19
// Locale: sv

const sv = {
  wieMoeglich: { question: 'Hur är det möjligt?', answer: 'Vi har tänkt om värdekedjan.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'STIG ROCK-vägen',
    fazit: 'Den förkortade leveranskedjan eliminerar de största kostnadsposterna.',
    fazitBigPre: 'Detta möjliggör en rabatt på upp till',
    fazitBigValue: '80%',
    steps: [ 'Gruva', 'Sliperi', 'Certifiering', 'Slutkund' ]
  },
  nav: { language: 'Språk', contact: 'Kontakt' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'En unik möjlighet',
    subtitle: 'Bygg förmögenhet för framtiden.',
    description: 'STIG ROCK är en internationell plattform som ger människor tillgång till naturliga diamanter, hållbar förmögenhetsuppbyggnad och en unik gemenskap.',
    scroll: 'Skrolla för att upptäcka'
  },
  disclaimer: {
    overline: 'Juridisk information',
    title: 'Disclaimer',
    paragraphs: [
      'Denna presentation är endast för information och utgör inte finansiell rådgivning, investeringsrådgivning eller skatterådgivning.',
      'STIG ROCK är inte en finansiell produkt, utan avser naturliga diamanter som materiella tillgångar.',
      'Inga garantier lämnas för värdeutveckling, vinster eller avkastning. Tidigare resultat är ingen indikation på framtida resultat.',
      'Alla beräkningar relaterade till provisioner är endast exempel och utgör inte heller någon garanti.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'BYGGD PÅ', 'STRUKTUR' ],
    body: 'STIG GROUP är en internationell koncern byggd på tydlighet, ansvar och långsiktigt värde. Varje varumärke, varje projekt och varje partnerskap följer en enda standard — utan genvägar, utan undantag.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'BYGGD PÅ', 'STRUKTUR' ],
        body: 'STIG GROUP är en internationell koncern byggd på tydlighet, ansvar och långsiktigt värde. Varje varumärke, varje projekt och varje partnerskap följer en enda standard — utan genvägar, utan undantag.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'EN VÄRLD AV', 'EXKLUSIVA DIAMANTER' ],
        body: 'STIG ROCK är ett modernt koncept från STIG GROUP som förenar högkvalitativa GIA-certifierade diamanter med transparenta strukturer och en exklusiv kundupplevelse. Tydliga lösningsplaner, professionell hantering och internationell inriktning.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'INTERNATIONELL', 'DIAMANTHANDEL' ],
        body: 'STIG INTERNATIONAL är en del av STIG GROUP och specialiserad på internationell handel med GIA-certifierade diamanter. Fokus på kvalitet, förtroende och moderna handelsstrukturer med globala partnerskap.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'ANSVAR FRÅN', 'GRUVAN' ],
        body: 'ETHICAL MINES står för ansvarsfull utvinning, spårbart ursprung och konfliktfria diamanter. Från gruva till marknad — fullständig dokumentation för transparens, integritet och långsiktigt ansvar genom hela leveranskedjan.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Diamanter',
    stigDrawback: 'Verklig värdebevarare',
    overline: 'Möjligheter',
    title: 'Möjligheter för förmögenhetsuppbyggnad',
    subtitle: 'Jämförelse med traditionella vägar.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex eller Krypto',
        drawback: 'höggradigt spekulativt, oförutsägbart, komplext'
      },
      {
        tag: 'Aktien',
        name: 'Börshandel',
        drawback: 'svängningsrisk, kräver kunskap, tidskrävande'
      },
      {
        tag: 'Krypto',
        name: 'Handel',
        drawback: 'volatilitet, regleringsrisk, säkerhetsluckor'
      }
    ]
  },
  chance: {
    overline: 'Diamanter',
    title: 'Den underskattade möjligheten',
    body: 'Diamanter har i åratal varit en av de mest värdestabila och lovande investeringsformerna, men hittills har få utnyttjat denna potential.',
    callout: 'Med vår STIG ROCK öppnar vi för första gången tillgången till dessa extraordinära möjligheter för alla.'
  },
  wertentwicklung: {
    overline: 'Värdeutveckling 1995 — 2025',
    title: 'En historia om värde.',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamanter',
    diamondValue: '+185%',
    note: 'Utveckling sedan 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Huvudskäl',
    title: 'Sex skäl till diamanter',
    lead: 'Diamanter är reala tillgångar som existerar oberoende av valutor och finansiella system — och har bevarat sitt värde i århundraden.',
    items: [
      {
        n: '01',
        title: 'Krissäker värdestabilitet',
        body: 'Garanti för materiella tillgångar. Oberoende av valutor och finansiella system.'
      },
      {
        n: '02',
        title: 'Den ultimata mobiliteten',
        body: 'Små, lätta att gömma och transportera.'
      },
      {
        n: '03',
        title: 'Diversifiering & knapphet',
        body: 'Brister i utbudet och naturlig begränsning.'
      },
      { n: '04', title: 'Långsiktig tillväxt', body: '+185% sedan 1995.' },
      {
        n: '05',
        title: 'Transparens & exklusivitet',
        body: 'De 4 C:na som garanti: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Kungahusens reserv',
        body: 'Till och med kungahus använder diamanter som förmögenhetsreserv.'
      }
    ]
  },
  markt: {
    overline: 'Marknadsvolym',
    title: '99 — 108 Mrd. USD',
    sub: 'Handelsvolym år 2025',
    forecast: 'Prognos till ~2032 / 2034: ca 140 – 168 Mrd. USD vid måttlig tillväxt (~4 – 5 % p.a.).',
    source: 'Källa: Fortune Business Insights'
  },
  innovation: {
    overline: 'STIG INTERNATIONAL — Innovation',
    title: 'En innovation. För första gången i världen.',
    body: 'STIG ROCK är världens första plattform som gör det möjligt för människor att tjäna en passiv inkomst på diamantmarknaden utöver värdeökningen.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Reg-nr. DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'Om företaget',
    titleLines: [ 'INTERNATIONELL', 'STRUKTUR', 'TYDLIG VISION' ],
    body: 'STIG ROCK grundades för att göra diamantmarknaden mer transparent, modern och kundorienterad — med fokus på förtroende, säkerhet och långsiktig struktur.'
  },
  sicherheit: {
    overline: 'Kvalitet & säkerhet',
    title: 'Gemological Institute of America',
    body: 'Certifierad expertis för dina diamanter. GIA utvärderar varje sten med högsta precision och mångårig erfarenhet — tillförlitliga värderingar för vårt företag och våra kunder.',
    transparency: 'Varje diamant uppfyller högsta kvalitetsstandarder och testas och certifieras av välkända organisationer. Varje sten är unik och får ett individuellt certifikat.'
  },
  plaene: {
    overline: 'Solution-planer (SP)',
    title: 'En unik produktinnovation',
    sub: 'Sex stegvisa Solution-planer — från $1K till $100K+, var och en med ökande rabatt per månad och under hela löptiden.',
    recommended: 'Populär',
    oneYear: '1 år',
    rowLabels: {
      delivery: 'Leveranstid',
      price: 'Produktpris',
      carat: 'Karat',
      monthly: 'Rabatt (månad)',
      totalDiscount: 'Rabatt (totalt)',
      duration: 'Löptid'
    },
    headers: {
      plan: 'Plan',
      from: 'Från',
      carat: 'Karat',
      monthly: 'Rabatt / mån',
      total: 'Rabatt totalt',
      duration: 'Löptid'
    },
    duration: '1 år',
    footnote: 'Alla prisuppgifter är utan garanti och beror på kvalitet, efterfrågan och aktuell marknadsutveckling. Solution-planer är även möjliga för 2 år.'
  },
  plaeneVIP: {
    overline: 'Solution-planer + VIP-paket',
    title: 'Fler fördelar med VIP-Paket',
    sub: 'Kombinera din Solution Plan med ett VIP-Paket och dra nytta av ytterligare prisfördelar på upp till 3 %. På så sätt ökar du din totalrabatt och säkerställer ännu mer attraktiva villkor.',
    rowLabels: {
      delivery: 'Leveranstid',
      price: 'Produktpris',
      carat: 'Karat',
      monthly: 'Rabatt (månad)',
      totalDiscount: 'Rabatt (totalt)',
      vip1: 'VIP-paket 1 (+1%)',
      vip2: 'VIP-paket 2 (+2%)',
      vip3: 'VIP-paket 3 (+3%)'
    },
    footnote: 'Alla prisuppgifter är utan garanti och beror på kvalitet, efterfrågan och aktuell marknadsutveckling.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Fler fördelar med VIP-Paket',
    sub: 'Kombinera din Solution Plan med ett VIP-Paket och dra nytta av ytterligare prisfördelar på upp till 3 %. På så sätt ökar du din totalrabatt och säkerställer ännu mer attraktiva villkor.',
    options: [
      {
        key: 'deliver',
        title: 'Fler fördelar med VIP-Paket',
        body: 'Diamanter (karat) till priset av din DS-Plan*'
      },
      {
        key: 'sellToUs',
        title: 'Sälj till oss',
        body: 'Du kan sälja tillbaka dina diamanter till oss för det inköpspris du betalade.'
      },
      {
        key: 'sellThirdParty',
        title: 'Sälj till tredje part',
        body: 'Du kan sälja vidare dina diamanter till tredje part.'
      }
    ],
    footnote: '*DS-Plan står för Solution-plan.'
  },
  tradWeg: {
    overline: 'Traditionell handel',
    title: 'Den traditionella vägen',
    sub: 'Innan en diamant når slutkunden uppstår betydande handelsmarginaler genom mellan-, grossist- och detaljhandel jämfört med rådiamantpriset från gruvan.',
    steps: [
      { title: 'Gruva', subtitle: 'Rådiamanter' },
      { title: 'Mellanhänder', subtitle: 'Inköp av rådiamanter' },
      { title: 'Sliperi', subtitle: 'Slipning till smyckesdiamanter' },
      { title: 'Zertifizierung', subtitle: 'genom erkända institut som GIA' },
      { title: 'Diamantbörs', subtitle: 'Försäljning till grossist' },
      { title: 'Großhandel', subtitle: 'Försäljning till detaljhandel' },
      { title: 'Einzelhandel', subtitle: 't.ex. juvelerare' },
      { title: 'Endkunden', subtitle: 'Köp av diamanter' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-paket',
    sub: 'Giltigt i 12 månader på alla Solution-planer du tecknat. Beroende på VIP-paket: +1% till +3% extra rabatt',
    cardKicker: 'extra – på alla',
    cardKicker2: 'Solution-planer',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Rabatter blir till besparingar',
      body: 'Månadsvis besparing istället för månadsvis belastning. Rabatter blir till besparingar – och dessa betalar precis de saker som du annars betalar ur egen ficka varje månad.',
      line1Label: 'DS-Plan från',
      line1Value: '$5.000',
      line2Label: 'mån. rabatt',
      line2Value: '3%',
      line3Label: 'VIP-paket 3',
      line3Value: '+3%',
      resultLabel: 'mån. besparingar',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Hur är detta möjligt?',
    title: 'Vi har tänkt om kring värdekedjan.',
    traditionalTitle: 'Den traditionella vägen',
    traditionalSteps: [
      'Gruva — Rådiamanter',
      'Mellanhänder — Inköp',
      'Sliperi — Slipning',
      'Zertifizierung (GIA)',
      'Diamantbörs — Grossist',
      'Großhandel → Detaljhandel',
      'Juvelerare → Slutkund'
    ],
    traditionalNote: 'Innan en diamant når slutkunden uppstår betydande handelsmarginaler genom mellan-, grossist- och detaljhandel.',
    stigTitle: 'Der STIG ROCK Weg',
    stigSteps: [
      'Direktköp — Rådiamanter från gruvan',
      'Slipning & certifiering av våra Partner',
      'Försäljning till slutkunder & B2B-kunder',
      'Upp till 4 handelscykler per år'
    ],
    stigNote: 'Vi bryter cirkeln och för vidare handelsmarginalerna som rabattkrediteringar till våra kunder — upp till 4 handelscykler under DS-Plan-löptiden.'
  },
  optionen: {
    overline: 'Dina möjligheter',
    title: 'Efter att din Solution-plan har löpt ut',
    items: [
      { title: 'Få levererat', body: 'Diamanter (karat) till priset av din DS-Plan.' },
      { title: 'Sälj till oss', body: 'Återförsäljning till det inköpspris du betalade.' },
      { title: 'Sälj till tredje part', body: 'Avyttra diamanter på den fria marknaden.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution-planer — en unik produktinnovation',
    title: 'Den enkla vägen',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Anmälan',
        body: 'Kontakta din rekommendationsgivare och skapa ett kostnadsfritt konto!'
      },
      { n: '02', icon: 'cart', title: 'Köp av en produkt', body: 'Redan från $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Få rabatter',
        body: 'Erhåll månatliga rabattkrediteringar.'
      }
    ]
  },
  business: {
    overline: 'Bonustyper',
    title: 'Det enklaste och mest rättvisa sättet.',
    sub: 'Fem bonustyper — för din framgångsrika affärsuppbyggnad.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Upp till nivå 3, från karriärsteg Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Från Sapphire — oändligt djupt.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'På Infinity Bonus – upp till nivå 5 · UTAN kvalificering.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 pooler av den globala omsättningen.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Engångsbonus i diamanter (karat).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Denna bonus betalas ut för varje nystartad Solution-plan upp till 3:e nivån. Med mycket låga kvalifikationer låser du upp de enskilda nivåerna.',
    total: 'Upp till 18% Unilevel Bonus',
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: 'från början',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: 'från karriärsteg Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: 'från karriärsteg Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'Från karriärsteg Sapphire är du kvalificerad för vår Infinity Bonus-plan. Du får 3% bonus. För varje nytt karriärsteg tillkommer ytterligare procent. Om en Partner i ditt team också är kvalificerad får du differensen mellan stegen.',
    exampleTitle: 'Exempel',
    exampleRows: [
      { label: 'Du är Blue Diamond', value: '12%' },
      { label: 'Din Partner är Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Din Infinity Bonus', value: '9%' },
    totalNote: 'Totalt upp till 24% Infinity Bonus på alla tecknade Solution-planer i ditt team — oändligt djupt.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'Med denna bonus drar du nytta av ditt teams framgång. Du får en Matching Bonus på 5% på dina partners Infinity Bonus — och det ner till 5:e nivån i ditt team.',
    note: 'På alla Infinity Bonus-betalningar i ditt team – ner till 5:e nivån. Från början – UTAN kvalificering.',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: 'Totalt upp till',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'World Pools',
    sub: '3% av den globala omsättningen går i lika delar till 3 olika pooler. Genom att nå vissa karriärsteg kvalificerar du dig för varje enskild pool.',
    forever: 'Nått en gång – delaktig för ALLTID!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'från Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'från Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'från Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Totalt',
    totalValue: '3%',
    totalSuffix: 'av den globala omsättningen'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Från karriärsteg Diamond får du en Rang Bonus. Denna betalas ut i diamanter (karat). Detta är en engångsbonus.',
    highlight: 'Diamanter (karat) till ett totalt värde av',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Karrierestufen',
    title: 'Karriärsteg',
    sub: 'För att nå respektive karriärsteg räknas den historiska totalomsättningen (HG). Från Sapphire-nivån måste denna vara fördelad på flera team. För att nå Ruby eller högre behöver du minst två direktpartner med en Solution-plan.',
    forever: 'Nått en gång – bekräftad för ALLTID!',
    footnote: 'HV = Historisk totalomsättning.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 dir. Pearl', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Satsa med oss',
    title: 'Rätt tid är precis nu.',
    body: 'Denna affärsmodell sätter nya standarder och förenar alla framgångsfaktorer för en långsiktigt hållbar och framgångsrik verksamhet. Registrera dig idag, välj din Solution-plan och utnyttja denna unika affärsmöjlighet.',
    hint: 'Prata med personen som bjöd in dig till denna presentation — de har en registreringslänk till dig.',
    formName: 'Namn',
    formEmail: 'E-post',
    formPhone: 'Telefon',
    formSubmit: 'Kontakta oss',
    success: 'Tack så mycket — vi kontaktar dig diskret och personligt.',
    callCta: 'Ring',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Juridisk information & Disclaimer',
    disclaimer: 'Denna presentation är endast för information och utgör inte finansiell rådgivning, investeringsrådgivning eller skatterådgivning. STIG ROCK är inte en finansiell produkt, utan avser naturliga diamanter som materiella tillgångar. Inga garantier lämnas för värdeutveckling, vinster eller avkastning. Tidigare resultat är ingen indikation på framtida resultat. Alla beräkningar relaterade till provisioner är endast exempel och utgör inte heller någon garanti. Vi förbehåller oss rätten till ändringar av innehållet — fri översättning (ingen officiell översättning).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG INTERNATIONAL. Alla rättigheter förbehållna.',
    version: 'Version: DS-12-2025 V3'
  },
  misc: { next: 'Nästa sektion' }
};

export default sv;
